import * as React from 'react';

const StoreShipLine: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                <path fill="currentColor" d="M14.57 0H5.83C4.43 0 3.18.82 2.6 2.09L.31 7.26C.1 7.71 0 8.2 0 8.7v12.49a3.53 3.53 0 0 0 3.53 3.53h17.64a3.53 3.53 0 0 0 3.53-3.53V8.69c0-.5-.1-.99-.31-1.44l-2.3-5.17a3.526 3.526 0 0 0-3.23-2.09h-4.3Zm1.32 7.05-.99-5.3h3.99c.69 0 1.33.41 1.62 1.05l1.89 4.24h-6.5Zm-1.8 0h-3.48l.99-5.3h1.49l1 5.3Zm.04 1.77v3.53H10.6V8.82h3.53Zm-5.3 0v3.53c0 .97.78 1.77 1.76 1.77h3.54c.97 0 1.77-.78 1.77-1.76V8.83h7.07v12.35c0 .97-.78 1.77-1.76 1.77H3.55c-.97 0-1.77-.78-1.77-1.76V8.85h7.07v-.03Zm-.01-1.77H2.33l1.89-4.24c.28-.64.91-1.05 1.62-1.05h4l-.99 5.3h-.01Z"/>
        </svg>
    );
};

export default React.memo(StoreShipLine);
